import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, createVNode as _createVNode, mergeProps as _mergeProps, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7afa92b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["hidden"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "input-controller"
}
const _hoisted_4 = {
  key: 0,
  class: "primary"
}
const _hoisted_5 = {
  key: 1,
  class: "item-display"
}
const _hoisted_6 = {
  key: 1,
  class: "select-controller"
}
const _hoisted_7 = {
  key: 0,
  class: "primary"
}
const _hoisted_8 = {
  key: 2,
  class: "select-controller"
}
const _hoisted_9 = {
  key: 0,
  class: "primary"
}
const _hoisted_10 = {
  key: 1,
  class: "flex-break"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_input = _resolveComponent("k-input")!
  const _component_IBDropdownCaseReport = _resolveComponent("IBDropdownCaseReport")!
  const _component_IBMultiSelectCaseReport = _resolveComponent("IBMultiSelectCaseReport")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ((_ctx.disabled && !_ctx.isEmptyValue) || !_ctx.disabled)
      ? (_openBlock(), _createElementBlock("div", _mergeProps({
          key: 0,
          class: "case-report-observation",
          hidden: _ctx.isHidden
        }, _ctx.$attrs, { class: _ctx.insightConfigSize }), [
          (!_ctx.isHidden)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_ctx.controller.type === 'input')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("label", null, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.t(`config.insight.case.${_ctx.activeCase.tissue}.${_ctx.observationKey}.title`)), 1),
                        (_ctx.controller.required)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
                          : _createCommentVNode("", true)
                      ]),
                      (!_ctx.disabled)
                        ? (_openBlock(), _createBlock(_component_k_input, {
                            key: 0,
                            required: _ctx.controller.required,
                            type: _ctx.controller.inputType,
                            disabled: _ctx.disabled,
                            min: _ctx.controller.min,
                            max: _ctx.controller.max,
                            step: _ctx.controller.step,
                            modelValue: _ctx.inputValue,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
                            onKeydown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                          }, null, 8, ["required", "type", "disabled", "min", "max", "step", "modelValue"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.inputValue), 1))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.controller.type === 'select')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("label", null, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.t(`config.insight.case.${_ctx.activeCase.tissue}.${_ctx.observationKey}.title`)), 1),
                        (_ctx.controller.required)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "*"))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_IBDropdownCaseReport, {
                        modelValue: _ctx.inputValue,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputValue) = $event)),
                        required: _ctx.controller.required,
                        disabled: _ctx.disabled,
                        prefill: _ctx.inputValue,
                        filterable: _ctx.controller.isFilterable,
                        options: _ctx.translatedOptions
                      }, null, 8, ["modelValue", "required", "disabled", "prefill", "filterable", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.controller.type === 'multi')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("label", null, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.t(`config.insight.case.${_ctx.activeCase.tissue}.${_ctx.observationKey}.title`)), 1),
                        (_ctx.controller.required)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "*"))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_IBMultiSelectCaseReport, {
                        modelValue: _ctx.inputValue,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputValue) = $event)),
                        disabled: _ctx.disabled,
                        options: _ctx.translatedOptions,
                        prefill: _ctx.inputValue,
                        required: _ctx.controller.required
                      }, null, 8, ["modelValue", "disabled", "options", "prefill", "required"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 16, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.isBreakAfter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10))
      : _createCommentVNode("", true)
  ], 64))
}